import { EmployeeCard } from "../components/EmployeeCard";
import { Plus } from "lucide-react";
import { Button } from "../../components/ui/button";
import { searchUsers, searchBusinesses } from "../services/employees";
import { toast } from "../../components/ui/use-toast";
import useEmployeesValidation from "../hooks/useEmployeesValidation";   // ⬅️ NEW

/* -------------------------------------------------------------------------- */
/*                          STEP-1  (Employees)                               */
/* -------------------------------------------------------------------------- */

export const PERMISSIONS = [
  { key: "managePosts", label: "Can manage posts" },
  { key: "createEvents", label: "Can create events" },
  { key: "placeAds", label: "Can place ads" },
  { key: "manageInbox", label: "Can manage inbox messages" },
  { key: "viewAnalytics", label: "Can view analytics" },
  { key: "manageFlashes", label: "Can manage flashes" },
  { key: "manageWorkingHours", label: "Can manage working-hours calendar" },
];

const MAX_EMPLOYEES = 20;

export default function Step1Employees({businessId, employees, setEmployees }) {
  const userSearch = (q, { signal }) =>
    searchUsers(q, businessId, signal);

  const businessSearch = (q, { signal }) =>
    searchBusinesses(q, businessId, signal);
  const addEmployee = () => {
    if (employees.length >= MAX_EMPLOYEES) {
      toast({
        title: `Limit reached`,
        description: `You can add up to ${MAX_EMPLOYEES} employees.`,
        variant: "destructive",
      });
      return;
    }
    setEmployees((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        identityType: "USER",
        roleType: "SERVICE_PROVIDER",
        fullName: "",
        email: "",
        picture: "",
        linkedUser: null,
        linkedBusiness: null,       
        permissions: PERMISSIONS.reduce((a, p) => ({ ...a, [p.key]: false }), {}),
        expanded: true,
      },
    ]);
  };
  const patch = (id, updater) =>
    setEmployees((prev) =>
      prev.map((e) => {
        if (e.id !== id) return e;
        const next = typeof updater === "function" ? updater(e) : { ...e, ...updater };
        // Bail if nothing really changed (cheap shallow check is enough here)
        for (const k in next) if (next[k] !== e[k]) return next;
        return e;
      })
    );
  const remove = (id) => setEmployees((prev) => prev.filter((e) => e.id !== id));
  const { errors } = useEmployeesValidation(employees);
  const errorMap = errors.reduce((acc, e) => {
    acc[e.id] = acc[e.id] ? [...acc[e.id], e.msg] : [e.msg];
    return acc;
  }, {});
  return (
    <div className="space-y-6">
      {employees.map((emp, i) => (
        <EmployeeCard
          key={emp.id}
          employee={emp}
          index={i}
          patch={(p) => patch(emp.id, p)}
          remove={() => remove(emp.id)}
          userSearch={userSearch}
          bizSearch={businessSearch}
          businessId={businessId}
          errorMsgs={errorMap[emp.id]}
        />
      ))}

      <Button
        variant="outline"
        className="gap-2"
        onClick={addEmployee}
        disabled={employees.length >= MAX_EMPLOYEES}
        title={
          employees.length >= MAX_EMPLOYEES
            ? `Maximum ${MAX_EMPLOYEES} employees allowed`
            : ""
        }
      >
        <Plus size={16} /> Add employee
      </Button>
    </div>
  );
}